import { html } from 'lit';
import { Mic } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-mic')
export class PdsIconMic extends PdsIcon {
  @state()
  icon = Mic;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
